import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setLoader } from "./MasterSlice";
import * as API from "../../utils/api.service";
import { TOAST_SUCCESS } from "../../utils/common.service";
import { data } from "jquery";

export const getladderLetterListApiCall = createAsyncThunk("ladderLetterList", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: ladderLetterList } = await API.getLadderLetterListApi(submitData);
        //  console.log("*********************************************",ladderLetterList);
        dispatch(setLoader(false))
        return ladderLetterList;
    } catch (error) {
        throw error;
    }
});

export const editLedderLetterDataApiCall = createAsyncThunk("editLedderLetterData", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: editLedderLetterData, code, message } = await API.updateLadderLetterApi(submitData);
        if (code === '1') {
            //TOAST_SUCCESS(message);
        }
        dispatch(setLoader(false))
        return { data: editLedderLetterData, code, message };
    } catch (error) {
        throw error;
    }
});

const initialState = {
    ladderLetterList: {
        data: [],
        error: null,
    },
    editLedderLetterData: {
        data: null,
        code: '',
        message: '',
        error: null,
    },
};

const ladderletterSlice = createSlice({
    name: "CLIENT",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getladderLetterListApiCall.fulfilled, (state, action) => {
                state.ladderLetterList.data = action.payload;
            })
            .addCase(getladderLetterListApiCall.rejected, (state, action) => {
                state.ladderLetterList.error = action.error.message;
            })
            .addCase(editLedderLetterDataApiCall.fulfilled, (state, action) => {
                const { message, code, data } = action.payload;
                state.editLedderLetterData.data = data;
                state.editLedderLetterData.message = message;
                state.editLedderLetterData.code = code;
            })
            .addCase(editLedderLetterDataApiCall.rejected, (state, action) => {
                state.editLedderLetterData.error = action.error.message;
            });
    },
});

export default ladderletterSlice.reducer;